import { atom } from "jotai";

export const singleTestPanelOpenAtom = atom<boolean>(false);
